import { useState } from "react";
import { useCookies } from "react-cookie";
import { toast } from "react-toastify";
import http from "../../../common/http-common";
import * as common from "../../../common/common";
import * as Comp from "../../../common/CommonComponents";

const DeleteServerConnType = (props) => {

    const [cookies] = useCookies([]);
    const [userId] = useState(cookies.USER_ID);
    const hideModal = () => {
        props.onHide();
    };

    const deleteBtnOnClick = () => {
        RemoveServerConnType(props.editData);
    };

    const RemoveServerConnType = (_data) => {
        let functionName = "";

        try {
            functionName = props.page + RemoveServerConnType.name;

            props.onLoading(true, "Deleting server, please wait...");
            props.onHide();

            const data = {
                SERVER_CONN_TYPE_ID: _data.SERVER_CONN_TYPE_ID,
                SERVER_CONN_TYPE_NAME: _data.SERVER_CONN_TYPE_NAME,
                UPDATE_ID: userId,
                FROM_SOURCE: { SOURCE: "WEB", MODULE_ID: props.module },
            };

            http
                .put("api/ServerConnType/DeleteServerConnType", data, { timeout: 5000 })
                .then(() => {
                    toast.success("Server is successfully deleted.");
                    props.onReload();
                })
                .catch((err) => {
                    toast.error("Failed to delete server. Please try again.");
                    common.c_LogWebError(props.page, functionName, err);
                })
                .finally(() => {
                    props.onLoading(false, "Loading...");
                });
        } catch (err) {
            props.onLoading(false, "Loading...");
            toast.error("Failed to delete server. Please try again.");
            common.c_LogWebError(props.page, functionName, err);
        }
    };
    //#endregion

    const message = (
        <>
            Confirm to delete?
            <br />
            Server :
            {<b> {props.editData !== null && props.editData.SERVER_ENV_NAME}</b>}
        </>
    );

    return (
        <>
            <Comp.ConfirmModal
                show={props.showHide}
                onHide={hideModal}
                onConfirm={deleteBtnOnClick}
                delete
            >
                {message}
            </Comp.ConfirmModal>
        </>
    );

};

export default DeleteServerConnType;